export function hasToken(tokenKey: string): boolean {
  const token = localStorage.getItem(tokenKey);
  return !!token;
}

export function countDiff(endTime: number) {
  return Math.floor((endTime - new Date().getTime()) / 1000);
}

export function setDisplayParamTokenValue(param: 'VISIBLE' | 'HIDDEN'): string {
  return param === 'VISIBLE' ? '1' : '0';
}
